"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var CacheProxy = /** @class */ (function () {
    function CacheProxy(cacheApiUrl) {
        this.cacheApiUrl = cacheApiUrl;
    }
    CacheProxy.prototype.setCacheApiUrl = function (cacheApiUrl) {
        this.cacheApiUrl = cacheApiUrl;
    };
    CacheProxy.prototype.getPrice = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            symbol: args.symbol,
                            provider: args.provider,
                            limit: 1,
                        };
                        // If timestamp is passed we fetch the latest price
                        // with timestamp which is less or equal to the passed one
                        if (args.timestamp !== undefined) {
                            params.toTimestamp = args.timestamp;
                        }
                        return [4 /*yield*/, axios_1.default.get(this.cacheApiUrl, { params: params })];
                    case 1:
                        data = (_a.sent()).data;
                        if (Array.isArray(data) && data.length === 1) {
                            return [2 /*return*/, data[0]];
                        }
                        else {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // If 'symbols' is not passed it will fetch prices for all tokens
    CacheProxy.prototype.getPriceForManyTokens = function (args) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = {
                            provider: args.provider,
                            toTimestamp: (_a = args.timestamp) !== null && _a !== void 0 ? _a : Date.now()
                        };
                        if (args.symbols !== undefined) {
                            params.symbols = args.symbols.join(",");
                        }
                        return [4 /*yield*/, axios_1.default.get(this.cacheApiUrl, { params: params })];
                    case 1:
                        data = (_b.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    CacheProxy.prototype.getManyPrices = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = lodash_1.default.pickBy(args, function (prop) { return !lodash_1.default.isUndefined(prop); });
                        return [4 /*yield*/, axios_1.default.get(this.cacheApiUrl, { params: params })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return CacheProxy;
}());
exports.default = CacheProxy;
